import ChartBox from "components/ChartBox"
import Donut from "components/Charts/Nivo/Donut"
import PieTooltip from "components/Charts/Nivo/tooltips/PieTooltip"
import { PieData } from "interfaces/charts/pie"

interface Props {
    data: [number, number]
}

const ActiveLivesComparasion = ({ data }: Props) => {
    
    const buildChartData = (values: [number, number]): PieData[] => {
        console.log(values);
        return [
            {
                id: "ativas",
                label: "Ativas",
                value: values[0],
            },
            {
                id: "inativas",
                label: "Inativas",
                value: values[1],
            },
        ]
    }

    return (
        <ChartBox title="Gestantes Ativas X Inativas">
            <Donut 
                data={buildChartData(data)}
                tooltip={PieTooltip}
            />
        </ChartBox>
    )
}

export default ActiveLivesComparasion